import React from "react";
import { Container, Card, CardBody } from "reactstrap";

import unauth from "../../assets/img/unauthorised-156169_1280.png";

import Header from "../../components/Headers/Header";

class Unauthorized extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <Header />
        <Container className="mt--9 main-content" fluid>
          <Card className="card-height">
            <CardBody className="align-items-center d-flex justify-content-center">
              <div className="text-center mt-5">
                <img src={unauth} height="70" width="70" alt=""/>
                <h1 className="mt-3">User do not have permission to access this page!</h1>
              </div>
            </CardBody>
          </Card>
        </Container>
      </>
    );
  }
}

export default Unauthorized;
